import React, { useMemo } from 'react';
import type { DocNode } from '@atlaskit/adf-schema';
import { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import { ReactRenderer } from '@atlaskit/renderer';
import { getEmojiProvider } from '@atlassian/jira-common-atlaskit-services/src/emoji.tsx';
import {
	onLinkClick,
	smartLinksDefault,
} from '@atlassian/jira-linking-platform-utils/src/index.tsx';

type ContentProps = {
	content: DocNode;
};

export const Content = ({ content }: ContentProps) => {
	const dataProviders = useMemo<ProviderFactory>(() => {
		const emojiProvider = getEmojiProvider();
		const providers = new ProviderFactory();
		providers.setProvider('emojiProvider', emojiProvider || undefined);

		return providers;
	}, []);

	return (
		<ReactRenderer
			document={content}
			dataProviders={dataProviders}
			eventHandlers={{
				link: { onClick: onLinkClick },
			}}
			smartLinks={smartLinksDefault}
		/>
	);
};
